export const svg2png = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      const svg = event.target!.result as string;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject('Failed to create canvas context');
        return;
      }
      const img = new Image();
      img.onload = () => {
        canvas.width = 1024;
        canvas.height = (img.height / img.width) * 1024;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/webp'));
      };
      const encodedSvg = new TextEncoder().encode(svg);
      // @ts-ignore
      const base64Svg = btoa(String.fromCharCode(...encodedSvg));
      img.src = `data:image/svg+xml;base64,${base64Svg}`;
    };
    reader.readAsText(file);
  });
};
